<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--醫師簡介維護程式-->
    <v-flex xs12>
        <v-card class="cardBgColorStyle">

            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn title="新增資料" @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                    <v-btn title="複製資料" @click="copyItem"  dark fab top right color="info" class="ml-1 mb-2 mt-0">
                        <v-icon >mdi-content-copy</v-icon>
                    </v-btn>

                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;margin-bottom: -5px">
                    {{this.menuInfo.funTitle}}
                </v-flex>


                <v-flex xs12 sm6 md4 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">科別代號</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2>
                        <v-autocomplete
                                @change="axios_getDoctorListData(zone,divNo)"
                                v-model="divNo"
                                hide-details
                                :items="divNoList"
                                :item-text="divItemText"
                                item-value="divNo"
                        ></v-autocomplete>
                    </v-flex>
                </v-flex>

                <v-flex xs12 sm6 md4 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">院區代號</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2>

                        <v-select
                                v-if="zoneNameList.length>0"
                                dark
                                @change="axios_getDoctorListData(zone,divNo)"
                                v-model="zone"
                                hide-details
                                :items="zoneNameList"
                                :item-text="zoneItemText"
                                item-value="zone"
                        ></v-select>

                        <v-text-field v-else  v-model="zone"   clearable @keyup.enter="axios_getDoctorListData(zone,divNo)"></v-text-field>
                    </v-flex>
                </v-flex>



                <!--<v-flex xs12 sm6 md4 d-inline-flex pl-2>-->
                    <!--<v-switch color="white" class="mr-2"  style="float: right" hide-details  :label="`${effFlag==true?'有效資料':'全部資料'}`" v-model="effFlag"></v-switch>-->
                <!--</v-flex>-->




            </v-card>



            <v-flex style="padding-top:1rem">
                <v-data-table
                        dense
                        :search="search"
                        id="funListTable"
                        :loading="funListLoading"
                        :headers="funListHeaders"
                        :items="doctorList"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeFunListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn icon class="mx-0" @click.native.stop="editItem(props.item)"> <!---->
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon class="mx-0" @click.native.stop="deleteItem(props.item)"><!---->
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>

                            </td>
                            <td  class="px-1 text-left" style="min-width: 80px">{{ props.item.displaySeq}} </td>
                            <td  class="px-1 text-left" style="min-width: 80px">{{ props.item.empNo}} </td>
                            <td  class="px-1 text-left" style="min-width: 100px">{{ props.item.empName}}</td>
                            <td  class="px-1 text-left" style="min-width: 50px">{{ props.item.divNo}}</td>
                            <td  class="px-1 text-left" style="min-width: 50px">{{ props.item.zone}}</td>
                            <td  class="px-1 text-left" >{{ props.item.empTitlename}}</td>
                            <td  class="px-1 text-left" style="white-space: pre-line" v-html="props.item.empDoc"></td>
                            <td  class="px-1 text-left" style="white-space: pre-line" v-html="props.item.empExper"></td>
                            <td  class="px-1 text-left" style="min-width: 120px">{{ $UtilityJs.AD2ROC_DateTime(props.item.stopEffDate,'date')}}</td>



                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">

                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>

                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="doctorList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-card>

        <v-dialog v-model="editDialog"
                  eager
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-doctor :is-copy="isCopy" :copy-obj="copyObj" :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-doctor>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <v-dialog v-model="copyDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>

            <search-copy-doctor @confirmCopy="confirmCopy" @closeCopy="closeCopy" :div-no-list="divNoList"></search-copy-doctor>

        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import EditDoctor from './EditDoctor'
    import SearchCopyDoctor from './SearchCopyDoctor'
    import DeleteInfoDialog from '../inursingsys/DeleteInfoDialog'
    export default {
        name: "DoctorMaintain",
        components: { DeleteInfoDialog,EditDoctor,SearchCopyDoctor},
        data() {
            return {
                searchCopyArray:[],
                isCopy:false,
                copyObj:{},
                copyDialog:false,
                copyEmpNo:'',
                copyDivNo:'',
                zoneNameList:[],
                zone:'ALL',//院區
                //程式功能清單
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                tableAlert:false,
                effFlag:true,
                funListLoading:false,
                loadingText:'查詢中...',
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 醫師簡介',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                doctorList: [],
                systemId:'',
                divNo:'',
                divNoList:[],
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                funListHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '顯示順序',
                        // align: 'left',
                        value: 'displaySeq',
                        class:'px-1'
                    },
                    {
                        text: '員工編號',
                        // align: 'left',
                        value: 'empNo',
                        class:'px-1'
                    },
                    {
                        text: '員工姓名',
                        // align: 'center',
                        value: 'empName',
                        class:'px-1'
                    },
                    {
                        text: '科別代號',
                        // align: 'center',
                        value: 'divNo',
                        class:'px-1'
                    },
                    {
                        text: '院區代號',
                        // align: 'center',
                        value: 'zone',
                        class:'px-1'
                    },
                    {
                        text: '員工職稱抬頭',
                        // align: 'center',
                        value: 'empTitlename',
                        class:'px-1'
                    },
                    {
                        text: '人員介紹',
                        // align: 'center',
                        value: 'empDoc',
                        class:'px-1'
                    },
                    {
                        text: '人員經歷',
                        // align: 'left',
                        value: 'empExper',
                        class:'px-1'
                    },
                    {
                        text: '停止使用日期',
                        // align: 'left',
                        value: 'stopEffdate',
                        class:'px-1'
                    },

                ]
            }
        },
        created(){
            this.axios_getDivNoList();//取得院區科別清單
            this.axios_getZoneNameALL();//取得院區清單

        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },

            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  50}
                if(this.$vuetify.breakpoint.xl ==true){width =  40}
                return width
            },

            // doctorDataFilter(){
            //     return this.doctorList.filter((item) => {
            //         if(this.divNo!==""){
            //             return (item.divNo==this.divNo);
            //         }else {
            //             return this.doctorList;
            //         }
            //
            //     });
            // },
        },
        watch:{
        },
        methods:{
            searchCopyDoctor(empNo,divNo){
                return this.doctorList.filter((item) => {
                    return item.empNo==empNo&&item.divNo==divNo
                });
            },
            closeCopy(){
              this.copyDialog = false;
              this.isCopy = false;
            },
            confirmCopy(empNo,divNo){
            this.axios_getCopyDoctor(empNo,divNo);
            },
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            divItemText: item => item.divNo==''?'':item.divNo + '-' + item.divName, //格式化 autocomplete 選權限顯示文字
            mapDivNo(){
              let divNoArray =  this.doctorList.map(function(obj) { return obj.divNo; });
              this.divNoList = Array.from(new Set(divNoArray));
              this.divNoList.unshift("")
            },
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓countDownId為null , countDownNo歸零
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.isCopy = false;
                this.axios_deleteDoctor(this.deleteObj);
            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            copyItem(){
              this.copyDialog = true;
              this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
                this.isCopy = false;
            },
            editItem:function(item){
                this.editIndex = this.doctorList.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                this.deleteContent = '確定要刪除，[員工編號 '+item.empNo+" / 員工姓名"+item.empName+" / 科別代號"+item.divNo+"]記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postDoctor(item);
                    this.isCopy = false;
                }else { //修改
                    this.axios_putDoctor(item);
                    this.isCopy = false;
                }
            },
            resizeFunListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                let height = userHeight-(270);
                let funListTable = document.getElementById('funListTable');
                funListTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getDoctorListData (zone,divNo){ //查詢醫師簡介全部清單
                this.countDown();//開始計時
                this.funListLoading = true;
                this.tableAlert = false;
                this.doctorList = [];
                let url = '';
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/datasearch/bydivno/"+zone+"/"+divNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;
                        // this.mapDivNo(); //過濾出
                    }else{
                        this.tableAlert = true;
                        this.doctorList = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                    } catch(err) {
                        this.doctorList = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                });
            },

            axios_postDoctor(postData){ //新增 醫師簡介
                let postList = [];
                postList.push(postData);
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/"+postData.zone;

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getDoctorListData('ALL','ALL');


                        // this.search = response.data.resultSet[0].dataType
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putDoctor(putData){ //修改 醫師簡介
                let postList = [];
                postList.push(putData);
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/"+putData.zone;

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getDoctorListData('ALL','ALL');

                        // this.search = response.data.resultSet[0].dataType

                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteDoctor(item){   //刪除單筆資料
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/s/"+zone+"/"+item.empNo+"/"+item.divNo;

                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getDoctorListData('ALL','ALL');
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getDivNoList(){ //取得科別清單
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                // url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/telandsubdiv/"+zone;
                url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/divsionall/"+zone; //抓出全部科別


                this.$http.get(url).then(response=>{
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                       this.divNoList = response.data.resultSet;
                        this.divNoList.unshift({divName: "全部科別",
                            divNo: "ALL",
                            telDivName: "全部科別",
                            telDivNo: "ALL"})
                       this.divNo = this.divNoList[0].divNo;
                        this.axios_getDoctorListData('ALL','ALL'); // 取得醫師簡介清單
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                        this.zoneNameList.unshift({zone: "ALL",zoneName: "全部"})
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
            axios_getCopyDoctor (empNo,divNo){  //查詢員工代號+科別
                this.searchCopyArray =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/datasearch/primarykeys/A/"+empNo+"/"+divNo;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.searchCopyArray = response.data.resultSet;
                        if(this.searchCopyArray.length>0){
                            this.isCopy = true;
                            this.copyObj = this.searchCopyArray[0];
                            this.editDialog = true;
                            this.copyDialog = false;
                        }
                    }else{
                        this.searchCopyArray =[];
                        alert('查無醫師資料');
                    }
                }).catch(error =>  {
                    this.searchCopyArray =[];
                    alert('查無醫師資料');
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },

        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }




</style>